/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LadderStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED'
} as const;
export type LadderStatus = typeof LadderStatus[keyof typeof LadderStatus];


export function instanceOfLadderStatus(value: any): boolean {
    for (const key in LadderStatus) {
        if (Object.prototype.hasOwnProperty.call(LadderStatus, key)) {
            if (LadderStatus[key as keyof typeof LadderStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LadderStatusFromJSON(json: any): LadderStatus {
    return LadderStatusFromJSONTyped(json, false);
}

export function LadderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderStatus {
    return json as LadderStatus;
}

export function LadderStatusToJSON(value?: LadderStatus | null): any {
    return value as any;
}

export function LadderStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LadderStatus {
    return value as LadderStatus;
}

